export default __webpack_public_path__ + "static/media/TL05.1.899df429.mp3";